export default __webpack_public_path__ + "static/media/header1.aa260c55.jpg";